import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';

export interface IToolbarAlert {
  label: string;
  tooltip: string;
  action: () => void;
}

@Component({
  selector: 'pr-toolbar-alert',
  templateUrl: './toolbar-alert.component.html',
  styleUrls: ['./toolbar-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatTooltip, NgCommonModule],
})
export class ToolbarAlertComponent {
  label = input<string>();
  tooltip = input<string>();
  action = output<void>();
}
